import React from 'react';
import { makeStyles, Dialog } from '@material-ui/core';
import ProgressBar from 'components/progressbar';
import ConfirmationPopup from 'components/confirmationPopup';
import ConfirmationVMAccessPopup from 'components/confirmationVmAccessPopup';

const useStyles = makeStyles({
    dialog: {
        "@media(max-width:860px)": {
            position: 'absolute',
            left: 100,
            top: 150
        },
        "@media(min-width:860px) and (max-width:1024px)": {
            position: 'absolute',
            left: 200,
            top: 150
        }
    }
});

export default function CustomizedDialogs(props) {
    const { type, closeModalPopup, handleLabTermination,sharingPortalUrl, labId, labName, id, content, handleLabVmAccess } = props;
    const classes = useStyles();

    const renderComp = () => {
        switch (type) {
            case 'activateLab':
                return <ProgressBar closeModalPopup={closeModalPopup} sharingPortalUrl={sharingPortalUrl} labId={labId} labName={labName} id={id} content={content}  />
            case 'terminateLab':
                return <ConfirmationPopup closeModalPopup={closeModalPopup} handleLabTermination={handleLabTermination} type={type}/>
            case 'disconnectLab':
                return <ConfirmationPopup closeModalPopup={closeModalPopup} handleLabTermination={handleLabTermination} type={type}/>
            case 'vmAccess':
                return <ConfirmationVMAccessPopup closeModalPopup={closeModalPopup} handleLabVmAccess={handleLabVmAccess} />
            default:
                return null;
        }
    }

    return (
        <div>
            <Dialog
                classes={{
                    paper: classes.dialog
                }}
                disableEscapeKeyDown={true}
                aria-labelledby="customized-dialog-title"
                open={true}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        closeModalPopup();
                    }
                }}

            >
                {renderComp()}
            </Dialog>
        </div>
    );
}
